import { render, staticRenderFns } from "./PasswordForm.vue?vue&type=template&id=b7e2f52e&scoped=true&"
import script from "./PasswordForm.vue?vue&type=script&lang=js&"
export * from "./PasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordForm.vue?vue&type=style&index=0&id=b7e2f52e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e2f52e",
  null
  
)

export default component.exports